import styled from 'styled-components'
import ChevronDownIcon from 'components/Common/Icons/ChevronDown'
import breakpoints from 'utils/consts/breakpoints'
import { useCollapse } from 'utils/hooks/useCollapseContent'
import useScreen from 'utils/screen'

const DesktopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 48px;
`

const MobileWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const Title = styled.div<{ $opened?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font: var(--typography-24-32-semibold);
  color: #121432;

  @media screen and ${breakpoints.device.tablet} {
    line-height: 28px;
  }

  @media screen and ${breakpoints.device.mobile} {
    font-size: 18px;
    line-height: 24px;
    padding: 16px 0;
    border-top: solid 1px #e7e7ea;
  }

  svg {
    transform: rotate(${props => (props.$opened ? '180deg' : '0')});
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 24px;

  @media screen and ${breakpoints.device.tablet} {
    padding-top: 16px;
  }

  @media screen and ${breakpoints.device.mobile} {
    padding-top: 0;
  }
`

const Gap = styled.div`
  display: flex;
  width: 100%;
  height: 24px;
`

const ActionsWrapper = styled.div`
  margin-top: 16px;
`

const MobileCollapsable = ({ title, actions, children }) => {
  const { opened, contentProps, toggle } = useCollapse()

  return (
    <MobileWrapper>
      <Title onClick={toggle} $opened={opened}>
        {title} <ChevronDownIcon size={24} color='#121432' />
      </Title>

      {/* @ts-ignore */}
      <Content {...contentProps}>
        {children}
        {actions && <ActionsWrapper>{actions}</ActionsWrapper>}
        <Gap />
      </Content>
    </MobileWrapper>
  )
}

const DesktopCollapsable = ({ title, actions, children }) => {
  return (
    <DesktopWrapper>
      <Title>
        {title}
        {actions}
      </Title>
      <Content>{children}</Content>
    </DesktopWrapper>
  )
}

const Collapsable = props => {
  const { isMobile } = useScreen()
  const Component = isMobile ? MobileCollapsable : DesktopCollapsable
  return <Component {...props} />
}

export default Collapsable
